import { render, staticRenderFns } from "./OutStock.vue?vue&type=template&id=731c1984&scoped=true&"
import script from "./OutStock.vue?vue&type=script&lang=js&"
export * from "./OutStock.vue?vue&type=script&lang=js&"
import style0 from "./OutStock.vue?vue&type=style&index=0&id=731c1984&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "731c1984",
  null
  
)

export default component.exports